import { createFileRoute } from '@tanstack/react-router';

// テストセット詳細 > 対象チケットタブ。
// 一覧は閲覧のみで URL search のスキーマは持たない(追加・解除は edit 配下の別画面)。
// コンポーネントは index.lazy.tsx 側で遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/test-sets/$id/_layout/target-tickets/')({});